import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment } from "react";
import { buildUpgradeUrl } from "@zapier/checkout";
import { Price } from "@zapier/currency";
import { Link } from "@zapier/design-system";
import { HeldTasksButton, TaskHistoryButton, UpgradeButton, } from "@zapier/upsells/esm/components";
const monthlyAmount = (amount, interval) => interval === "year" ? amount / 12 : amount;
const baseBodyText = (_jsxs(Fragment, { children: ["You've run out of available tasks on your account, and", " ", _jsx(Link, { href: "/help/manage/tasks/learn-about-tasks-in-zapier", target: "_blank", children: "your tasks are held" }), "."] }));
const views = {
    ["LEAVING_FREE"]: ({ currency, destinationPlan, upgradeUrl, }) => ({
        bodyText: (_jsxs(Fragment, { children: ["All", " ", _jsx(Link, { href: "/help/manage/history/learn-about-tasks-in-zapier", children: "tasks from your Zaps" }), " ", "will be held until you upgrade your plan or your monthly usage resets.", " ", "Get access to ", Number(destinationPlan.tasks).toLocaleString(), " tasks with the ", destinationPlan.type, " plan for", " ", _jsx(Price, { currency: currency, children: monthlyAmount(destinationPlan.amount, destinationPlan.interval) }), " ", "per month."] })),
        buttons: [
            _jsx(TaskHistoryButton, {}, "LEAVING_FREE-task-history-button"),
            _jsx(UpgradeButton, { href: upgradeUrl }, "LEAVING_FREE-upgrade-button"),
        ],
        type: "LEAVING_FREE",
    }),
    ["NEW_PLAN_TYPE"]: ({ currency, currentPlan, destinationPlan, upgradeUrl, }) => ({
        bodyText: currentPlan ? (_jsxs(Fragment, { children: [baseBodyText, " Upgrade to a Zapier ", destinationPlan.type, " plan now to get ", Number(destinationPlan.tasks).toLocaleString(), " monthly tasks for", " ", _jsx(Price, { currency: currency, children: monthlyAmount(destinationPlan.amount, destinationPlan.interval) -
                        monthlyAmount(currentPlan.amount, currentPlan.interval) }), " ", "more per month."] })) : undefined,
        buttons: [
            _jsx(HeldTasksButton, {}, "NEW_PLAN_TYPE-held-tasks-button"),
            _jsx(UpgradeButton, { href: upgradeUrl }, "NEW_PLAN_TYPE-upgrade-button"),
        ],
        type: "NEW_PLAN_TYPE",
    }),
    ["NEW_TASK_LIMIT_SAME_PLAN_TYPE"]: ({ currency, currentPlan, destinationPlan, upgradeUrl, }) => ({
        bodyText: (_jsxs(Fragment, { children: [baseBodyText, " Upgrade your plan now to get", " ", Number(destinationPlan.tasks).toLocaleString(), " monthly tasks for", " ", _jsx(Price, { currency: currency, children: monthlyAmount(destinationPlan.amount, destinationPlan.interval) -
                        monthlyAmount(currentPlan.amount, currentPlan.interval) }), " ", "more per month."] })),
        buttons: [
            _jsx(HeldTasksButton, {}, "NEW_TASK_LIMIT_SAME_PLAN_TYPE-held-tasks-button"),
            _jsx(UpgradeButton, { href: upgradeUrl }, "NEW_TASK_LIMIT_SAME_PLAN_TYPE-upgrade-button"),
        ],
        type: "NEW_TASK_LIMIT_SAME_PLAN_TYPE",
    }),
};
export const getActiveView = ({ activeTrialType, currency, currentPlan, destinationPlan, }) => {
    const upgradeUrl = buildUpgradeUrl(null, destinationPlan.name, currentPlan.interval);
    const activeViewProps = {
        currency,
        currentPlan,
        destinationPlan,
        upgradeUrl,
    };
    if (activeTrialType === "Team" || activeTrialType === "Company") {
        return views.NEW_PLAN_TYPE(activeViewProps);
    }
    if (activeTrialType === "Professional" || currentPlan.amount === 0) {
        return views.LEAVING_FREE(activeViewProps);
    }
    if (currentPlan.type === (destinationPlan === null || destinationPlan === void 0 ? void 0 : destinationPlan.type)) {
        return views.NEW_TASK_LIMIT_SAME_PLAN_TYPE(activeViewProps);
    }
    return views.NEW_PLAN_TYPE(activeViewProps);
};

// @zapier/upsells@8.0.3 (1de7a616e)
